import React from "react";

import { ContactPageContainer } from "./ContactPage.container";
import { ContactPageView } from "./ContactPage.view";

export function ContactPage(props) {
  return (
    <ContactPageContainer.Provider initialState={props}>
    <ContactPageView />
    </ContactPageContainer.Provider>
  );
}
export async function getServerSideProps(context) {
  return {
    props: {}
  };
}

